import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory, useLocation } from "react-router-dom";
import BadgeStatus from "../../../common/BadgeStatus";
import { GET, newFetch, PUT } from "../../../helpers/fetch";
import Spinner from "../../SpringLoader/index";
import AlertService from "../../SweetAlert";
import ToastUtil from "../../ToastNotification/ToastUtil";
import LeaveForm from "../LeaveForm";

const LeaveView = () => {
  const { t } = useTranslation();
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [currentLeave, setCurrentLeave] = useState(null);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const initialLeave = location.state?.leaveData;

  const fetchAll = async () => {
    try {
      let api_path = `/associate-leaves/${
        JSON.parse(localStorage.getItem("user")).id
      }`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setLeaves(response.data);
        setLoading(false);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCancel = async (leave) => {
    if (
      await AlertService.confirm(
        "",
        "Are you sure you want to cancel the leave?"
      )
    ) {
      const editStatus = "Cancelled";
      const api_path = `/associate-leaves/cancel-leave/${leave.id}`;

      const response = await newFetch(PUT, api_path, { editStatus });

      if (response.success) {
        ToastUtil.success(response.message);
        setCurrentLeave((prevLeave) => ({
          ...prevLeave,
          status: "Cancelled",
        }));
        updateState();
      } else {
        ToastUtil.error(response.message);
      }
    }
  };

  const updateState = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    fetchAll();
  }, [update]);

  useEffect(() => {
    if (initialLeave) {
      setCurrentLeave(initialLeave);
    }
  }, [initialLeave]);

  const displayLeave = currentLeave || initialLeave;

  if (!displayLeave) {
    return <div>{t("No leave data available")}</div>;
  }

  const leaveStatus = String(displayLeave.status || "").toLowerCase();
  const canCancelLeave =
    leaveStatus.includes("pending") &&
    !leaveStatus.includes("pending cancellation");

  return (
    <div>
      <div className="container pt-4">
        <h4 className="text-brand">
          <Link to="/leave">
            <i
              className="fas fa-arrow-left link"
              style={{ cursor: "pointer" }}
            />
          </Link>
          &nbsp;&nbsp;{t("Leave Request")} | {displayLeave.id}
        </h4>
        <div className="d-flex justify-content-between my-3">
          <div>
            <div className="header-thick">Status</div>
            <BadgeStatus status={displayLeave.status} />
          </div>
          {canCancelLeave && (
            <div className="d-flex align-items-center">
              <button
                className="btn btn-dark"
                onClick={() => handleCancel(displayLeave)}
              >
                Cancel Leave
              </button>
            </div>
          )}
        </div>

        <div className="accordion my-3 bg-white" id="accordionFAQs">
          {loading ? (
            <Spinner />
          ) : (
            <LeaveForm updateState={updateState} leaveData={displayLeave} />
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaveView;
